import { Clock } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useOutletContext } from 'react-router-dom'
import { PageShell } from '@/components/layout/PageShell'
import { Card } from '@/components/ui/card'
import { ReportExportButton, type ReportOutletContext } from '../../ReportLayout'

export default function ReportAuditPage() {
  const { t } = useTranslation()
  const { handleExportPdf, isGeneratingReport } = useOutletContext<ReportOutletContext>()
  return (
    <PageShell
      layout="padded"
      icon={Clock}
      title={t('cases.report.audit.title')}
      summary={t('cases.report.audit.summary')}
      toolbar={<ReportExportButton onExport={handleExportPdf} isExporting={isGeneratingReport} />}
    >
      <Card className="p-6">
        <div className="flex flex-col items-center justify-center py-12 text-center">
          <Clock className="size-8 text-muted-foreground mb-2" />
          <p className="text-sm font-medium text-foreground">Audit Trail</p>
          <p className="text-xs text-muted-foreground mt-1">
            Track all actions and changes made during the investigation. Coming soon.
          </p>
        </div>
      </Card>
    </PageShell>
  )
}
